<div class="login">
    <nav class="navbar">
        <a class="navbar-brand" href="javascript:void(0)" (click)="goBack()">&larr; Back to previous page</a>
    </nav>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col-xs-12 col-md-6 offset-md-3">
                <img src="./assets/sos-logo.svg" class="logo">
            </div>
        </div>
        <div class="row" *ngIf="hasError">
            <div class="col-xs-12 col-md-6 offset-md-3 mt-5 alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Oh no!</strong> Looks like you've entered the wrong username or password. Please try again.
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-xs-12 col-md-6 offset-md-3">
                <label for="exampleFormControlInput1" class="form-label mb-3">Log in with your email</label>
                <input type="email" class="form-control" id="email" (input)="emailValid()" placeholder="Email" formControlName="identifier" required>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-xs-12 col-md-6 offset-md-3">
                <input type="password" class="form-control" id="password" (input)="passwordValid()" placeholder="Password" formControlName="password" required>
            </div>
        </div>
        <div class="row mt-2 mb-3">
            <div class="col-xs-12 col-md-6 offset-md-3">
                <a class="float-end password" routerLink="/forgot-password">Forgot your password?</a>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-xs-12 col-md-6 offset-md-3 d-grid">
                <button type="submit" class="btn btn-primary btn-lg login-btn" [disabled]="loginForm.invalid">Continue</button>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xs-12 col-md-6 offset-md-3 d-grid">
                <span class="help" routerLink="/signup">Don't have an account? <span class="signup">Sign Up</span></span> 
            </div>
        </div>
    </form>
</div>
